import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { dealingCardsPollTimeoutToken } from '../../providers/dealing-cards-poll-timeout.provider'

@Component({
  selector: 'sans-dealing-cards',
  standalone: true,
  imports: [],
  templateUrl: './dealing-cards.component.html',
  styleUrl: './dealing-cards.component.scss',
})
export class DealingCardsComponent implements OnInit, OnDestroy {
  private pollingIntervalId = setTimeout(() => {})
  @Output() public timerExpired = new EventEmitter<void>()

  public dealingCardsLabel = $localize`:Dealing cards component|Dealing cards label:Dealing cards`

  public constructor(
    @Inject(dealingCardsPollTimeoutToken)
    private readonly dealingCardsPollTimeout: number,
  ) {}

  public ngOnInit(): void {
    this.pollingIntervalId = setInterval(() => {
      this.timerExpired.emit()
    }, this.dealingCardsPollTimeout)
  }

  public ngOnDestroy(): void {
    clearInterval(this.pollingIntervalId)
  }
}
